export const name = 'InlinePopupAspect'

export const defaultModel = {
    openedId: null
}
